<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-edit-invoice-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'EditInvoice',
  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreEditInvoiceView: () => import('../components/core/EditInvoiceView'),
    CoreFooter: () => import('../components/core/Footer'),
  },
  data: () => ({
    expandOnHover: false,
  }),
}
</script>
